module.exports = __webpack_public_path__ + "img/hammam_GRA.8bd29450.jpg";